import { cn } from '@shared/lib';

interface ToggleProps {
  on: boolean;
  onChange: (next: boolean) => void;
  size?: 'sm' | 'md';
  className?: string;
  disabled?: boolean;
  /** Неактивен на время запроса, но фокус остаётся на переключателе (`disabled` уронил бы его на body). */
  ariaDisabled?: boolean;
  ariaLabel?: string;
}

const sizeMap = {
  sm: {
    track: 'h-[18px] w-8',
    thumb: 'h-3.5 w-3.5',
    thumbOn: 'translate-x-3.5',
  },
  md: {
    track: 'h-6 w-11',
    thumb: 'h-[18px] w-[18px]',
    thumbOn: 'translate-x-5',
  },
};

export function Toggle({ on, onChange, size = 'md', className, disabled, ariaDisabled, ariaLabel }: ToggleProps) {
  const s = sizeMap[size];
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      aria-disabled={ariaDisabled || undefined}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (ariaDisabled) return;
        onChange(!on);
      }}
      className={cn(
        'relative shrink-0 rounded-pill p-0 transition-colors duration-150',
        'before:absolute before:-inset-2.5 before:rounded-pill before:content-[""]',
        on ? 'bg-accent' : 'bg-line',
        (disabled || ariaDisabled) && 'opacity-40 cursor-not-allowed',
        s.track,
        className,
      )}
    >
      <span className="pointer-events-none absolute inset-0 flex items-center px-[3px]">
        <span
          className={cn(
            'block rounded-pill bg-fg transition-transform duration-150',
            s.thumb,
            on && s.thumbOn,
          )}
        />
      </span>
    </button>
  );
}
